import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Badge } from "@/components/ui/badge";
import { Loader2, Search } from "lucide-react";

export const ArticleSearch = ({ onPick }) => {
  const [q, setQ] = useState("");
  const { data = [], isFetching } = useQuery({
    queryKey: ["cut-articles", q], enabled: q.trim().length >= 2,
    queryFn: async () => (await api.get("/cut-tickets/articles", { params: { q } })).data,
  });
  return (
    <div className="space-y-2">
      <div className="relative">
        <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
        <Input autoFocus value={q} onChange={(e) => setQ(e.target.value)} className="pl-9" placeholder="Cerca per codice o nome, es. 8001 A26" data-testid="ticket-article-search" />
      </div>
      {isFetching && <Loader2 className="h-4 w-4 animate-spin text-primary" />}
      {q.trim().length >= 2 && !isFetching && (
        <div className="max-h-72 divide-y divide-border overflow-y-auto rounded-md border border-border" data-testid="ticket-article-results">
          {data.length === 0 && <p className="p-3 text-sm text-muted-foreground">Nessun articolo trovato tra il sito e le schede tecniche.</p>}
          {data.map((a) => (
            <button key={a.key} type="button" onClick={() => onPick(a)} className="flex w-full items-center gap-3 px-3 py-2 text-left text-sm transition-colors hover:bg-secondary/50" data-testid={`ticket-article-${a.key}`}>
              <span className="min-w-0 flex-1">
                <span className="font-medium">{a.code || "Senza codice"}</span> · {a.name}
                <span className="block text-xs text-muted-foreground">{a.colors.join(" · ") || "Nessun colore"} — {a.sizes.join(" ")}</span>
              </span>
              {a.on_site && <Badge variant="outline" className="text-[10px]">sul sito</Badge>}
              {a.sheet_id && <Badge variant="outline" className="text-[10px]">scheda tecnica</Badge>}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
